import React, { FC } from 'react';
import _ from 'lodash';
import { Box, Text } from '@wix/design-system';
import { TFunction } from '@wix/fe-essentials-standalone/i18n';
import { TemplateGalleryCard } from '@common/types';
import PurchaseSvg from '@components/Images/PurchaseSvg';
import TemplateStar from '@components/Images/TemplateStar';
import s from '../TemplateCard.module.scss';

interface Props {
  template: TemplateGalleryCard;
  t: TFunction;
  language: string;
}

const RatingBar: FC<Props> = ({ template, t, language }) => {
  const hasReview = _.get(template, 'review.total', 0) > 0;
  const hasPurchases = template.purchaseCount > 0;

  function renderReviewStatus() {
    return hasReview ? (
      <Box gap="2px" verticalAlign="middle">
        <Box>
          <TemplateStar />
        </Box>
        <Box
          dataHook="template-review-status"
          align="center"
          gap="2px"
          direction="horizontal"
          verticalAlign="middle"
        >
          <Text
            dataHook="template-review-status-text"
            size="tiny"
            className={s.textColor}
          >
            {Intl.NumberFormat(language, {
              maximumFractionDigits: 1,
              minimumFractionDigits: 1,
            }).format(template!.review!.average)}
          </Text>
          <Text weight="thin" size="tiny" className={s.textColor}>
            ({Intl.NumberFormat(language, {}).format(template!.review!.total)})
          </Text>
        </Box>
      </Box>
    ) : (
      <Text size="tiny" weight="thin" className={s.textColor}>
        {String(t('marketplace.templates-page.rating-bar.no-reviews'))}
      </Text>
    );
  }

  return (
    <Box paddingTop="4px" gap="6px" verticalAlign="middle">
      {renderReviewStatus()}
      {hasPurchases && (
        <Box gap="2px" direction="horizontal" verticalAlign="middle">
          <PurchaseSvg />
          <Text size="tiny" className={s.textColor}>
            {Intl.NumberFormat(language, {}).format(template.purchaseCount)}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default RatingBar;
